var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurKeywords",
      staticStyle: { width: "100%" },
      attrs: { flat: "", id: "conteneurKeywords" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialog")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialog) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.submitDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-text", [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c("v-progress-circular", {
                  staticClass: "primary--text",
                  attrs: { indeterminate: "", size: 100, width: 1 }
                })
              ],
              1
            )
          : _c(
              "div",
              [
                _vm.locked
                  ? _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", icon: "", color: "red" },
                            on: { click: _vm.toggleLocked }
                          },
                          [_c("v-icon", [_vm._v("lock")])],
                          1
                        ),
                        _vm._v(
                          " " + _vm._s(_vm.$t("AIPageLock")) + "\n            "
                        )
                      ],
                      1
                    )
                  : _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              flat: "",
                              icon: "",
                              color: "grey lighten-1"
                            },
                            on: { click: _vm.toggleLocked }
                          },
                          [_c("v-icon", [_vm._v("lock")])],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("AIPageNoLock")) +
                            "\n            "
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.updatedKeywords
                  ? _c("v-alert", { attrs: { value: true, type: "warning" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("AIRepSeg")) +
                          "\n            "
                      )
                    ])
                  : _c("v-alert", { attrs: { value: true, type: "success" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("AIRepResSeg")) +
                          "\n            "
                      )
                    ]),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    box: "",
                    name: "contentDialog",
                    label: this.$t("keywords"),
                    "auto-grow": "",
                    value: _vm.contentDialog
                  },
                  model: {
                    value: _vm.contentDialog,
                    callback: function($$v) {
                      _vm.contentDialog = $$v
                    },
                    expression: "contentDialog"
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.keys, function(key, index) {
                  return _c("v-text-field", {
                    key: index,
                    attrs: { label: key[0], value: key[1] },
                    on: {
                      input: function($event) {
                        return _vm.changeKey($event, key[0])
                      }
                    }
                  })
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", color: "blue" },
                    on: { click: _vm.toggleViewJSON }
                  },
                  [_c("v-icon", [_vm._v("info")])],
                  1
                ),
                _vm._v(" " + _vm._s(_vm.$t("AIDetailJSON")) + "\n            "),
                _vm.viewJSON
                  ? _c("v-textarea", {
                      attrs: {
                        box: "",
                        name: "keys",
                        label: this.$t("AIResumCritere"),
                        "auto-grow": "",
                        value: _vm.keys
                      }
                    })
                  : _vm._e()
              ],
              2
            )
      ]),
      _vm._v(" "),
      !_vm.$vuetify.breakpoint.smAndDown &&
      !_vm.closeDialogUniquement &&
      !_vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("no")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.loadingModif,
                    disabled: _vm.loadingModif,
                    color: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.submitDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              )
            ],
            1
          )
        : !_vm.$vuetify.breakpoint.smAndDown &&
          !_vm.closeDialogUniquement &&
          _vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("justCloseDialog")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeDialog")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("ok")))]
              )
            ],
            1
          )
        : _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f0d9fab", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0d9fab","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogOpenAIKeyword.vue
// module id = null
// module chunks = 